import { Link } from "react-router";
import { ArrowRight } from "lucide-react";
import { EVENT, EVENT_ENDS as ENDS } from "./events/event";
import "./EventStrip.css";


export const STRIP_VARIANTS = ["original", "night", "candle", "pumpkin", "paper", "marquee", "gold"] as const;
export type StripVariant = typeof STRIP_VARIANTS[number];

/** A slim announcement bar above the nav. Each variant is one visual idea in
    at most three colors; `variant` picks it (the lab page shows them all). */
export function EventStrip({ variant = "original", force = false }: { variant?: StripVariant; force?: boolean }) {
  if (!force && Date.now() >= ENDS.getTime()) return null;
  const when = `${EVENT.weekday}, ${EVENT.month} ${EVENT.day} · ${EVENT.time}`;
  return <Link to={EVENT.href} className={`es es-${variant}`}>
    {(variant === "candle" || variant === "paper" || variant === "original") && <img className="es-poster" src={EVENT.poster} alt="" width={1080} height={1350} />}
    <span className="es-copy">
      <span className="es-label">{variant === "marquee" ? "Now showing" : "Halloween movie night"}</span>
      <b>Watch <i>{EVENT.film}</i> &amp; Craft With Me!</b>
      <span className="es-meta">{EVENT.title} · {when} · {EVENT.city.replace(/, \w+$/, "")}</span>
    </span>
    <span className="es-cta">Tickets · {EVENT.price} <ArrowRight size={15} aria-hidden="true" /></span>
  </Link>;
}
